import React from "react";

import classNames from "classnames";

import customDropdownStyle from "assets/jss/material-dashboard-pro-react/components/customDropdownStyle.jsx";

import FileEndpoints from "../../../api/FileEndpoints";
import FileBlock from "../../../components/Files/FileBlock";
import { withStyles, Menu, MenuItem, IconButton } from "@material-ui/core";

import Share from '@material-ui/icons/Share';
import CloudDownload from '@material-ui/icons/CloudDownload';
import Edit from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete';
import DeleteSweep from '@material-ui/icons/DeleteSweep';
import CreateNewFolder from '@material-ui/icons/CreateNewFolder';
import FolderShared from '@material-ui/icons/FolderShared';
 
import Loading from "../../../components/Loading/Loading";
import FileDownloadHelper from "../../../helpers/FileDownloadHelper";
import Api from "../../../api/Api.js";
import CustomInput from "../../../components/CustomInput/CustomInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes, faFolderOpen } from "@fortawesome/pro-solid-svg-icons";
import { store } from "../../../redux/store";
import { replace } from "connected-react-router";

class Files extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      fileMenuAnchor: null,
      folderMenuAnchor: null,

      selectedFile: null,
      renameOpen: false,
      file_new_name: '',
      file_new_nameState: '',
      deleteOpen: false,
      shareOpen: false,
      shareCopied: false,

      selectedFolder: null,
      renameFolderOpen: false,
      folder_new_name: '',
      folder_new_nameState: '',
      nameOfNewFolder: '',
      nameOfNewFolderState: '',
      deleteFolderOpen: false,
      shareFolderOpen: false,
      shareFolderCopied: false,
      createFolderOpen: false,

      emptyContextOpen: false,
      emptyTop: 0,
      emptyLeft: 0
    }
  }

  onContextMenuFolder(e, folder) {
    e.preventDefault();
    this.setState({ folderMenuAnchor: e.currentTarget, selectedFolder: folder });
  }
  onClickFolder(folder) {
    this.closeMenus();
    this.props.onRefreshRequired(folder.name);
    store.dispatch(replace("/customers/view/" + this.props.customer_id + "/1/" + folder.name))
  }

  onContextMenuFile(e, file) {
    e.preventDefault();
    this.setState({ fileMenuAnchor: e.currentTarget, selectedFile: file });
  }

  closeMenus() {
    this.setState({
      fileMenuAnchor: null,
      folderMenuAnchor: null
    })
  }

  onClickFile(file) {
    this.closeMenus();
    Api.fileDownload(FileEndpoints.download, file)
      .then(({ data }) => FileDownloadHelper(data, file.mimeType, file.original_name));
  }

  renameFile() {
    Api.get(FileEndpoints.rename, { id: this.state.selectedFile.id, new_name: this.state.file_new_name })
      .then(({ }) => { this.setState({ renameOpen: false }, () => this.props.onRefreshRequired(this.props.files.name)); });
  }

  deleteFile() {
    Api.get(FileEndpoints.delete, { id: this.state.selectedFile.id })
      .then(({ }) => { this.setState({ deleteOpen: false }, () => this.props.onRefreshRequired(this.props.files.name)); });
  }

  shareFile() {
    Api.get(FileEndpoints.share, { id: this.state.selectedFile.id });
  }

  createFolder() {
    Api.get(FileEndpoints.createFolder, { folder: this.state.nameOfNewFolder, account_id: this.props.customer_id })
      .then(({ }) => { this.setState({ createFolderOpen: false }, () => this.props.onRefreshRequired(this.props.files.name)); });
  }

  renameFolder() {
    Api.get(FileEndpoints.renameFolder, { folder: this.state.selectedFolder.name, account_id: this.props.customer_id, new_name: this.state.folder_new_name })
      .then(({ }) => { this.setState({ renameFolderOpen: false }, () => this.props.onRefreshRequired(this.state.selectedFolder.name)); });
  }

  deleteFolder() {
    Api.get(FileEndpoints.deleteFolder,{ folder: this.state.selectedFolder.name, account_id: this.props.customer_id })
      .then(({ }) => { this.setState({ deleteFolderOpen: false }, () => this.props.onRefreshRequired(this.state.selectedFolder.name)); });
  }

  shareFolder() {
    Api.get(FileEndpoints.shareFolder, { folder: this.state.selectedFolder.name, account_id: this.props.customer_id });
  }

  onDragOverItem(e) {
    e.preventDefault();
  }

  onDropBack(e) {
    var file_id = e.dataTransfer.getData("id");
    Api.get(FileEndpoints.move, { id: file_id, folder: null }).then(() => this.props.onRefreshRequired(this.props.files.name));
  }

  onFolderDrop(e, folder_name) {
    var file_id = e.dataTransfer.getData("id");
    Api.get(FileEndpoints.move, { id: file_id, folder: folder_name }).then(() => this.props.onRefreshRequired(folder_name));
  }

  onFileDrag(e, file_id) {
    e.dataTransfer.setData("id", file_id);
  }

  render() {
    const { classes } = this.props;

    //var a = new HTMLElement();
    //a.clientLeft.offsetTop

    const dropdownItem = classNames({
      [classes.dropdownItem]: true,
      [classes.primaryHover]: true,
      [classes.alignLeft]: true
    });

    if (!this.props.files || !this.props.files.uploads)
      return <Loading />;

    return (
      <div
        style={{ width: '100%', height: '100%', padding: 5, boxShadow: 'inset 0px 0px 24px -8px rgba(0,0,0,0.75)', backgroundColor: '#f7f7f7', borderRadius: 5, display: 'flex', flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'space-evenly', alignContent: 'flex-start' }}
      >
        {
          this.props.showBack ?
            <FileBlock
              folder
              fileType={'back'}
              fileName={" "}
              mainContainerStyle={{ zIndex: 1, height: 110 }}
              onContextMenu={(e) => e.preventDefault()}
              onClick={() => { this.props.onRefreshRequired(this.props.files.name); store.dispatch(replace("/customers/view/" + this.props.customer_id + "/1")); }}
              onDragOver={(e) => this.onDragOverItem(e)}
              onDrop={(e) => this.onDropBack(e)}
            />
            : null
        }

        {
          this.props.files.folders.map(folder => {
            return (
              <FileBlock
                folder
                shared={folder.shared}
                key={folder.name}
                fileType={'folder'}
                fileName={folder.name}
                mainContainerStyle={{ zIndex: 1, height: 110 }}
                onContextMenu={(e) => this.onContextMenuFolder(e, folder)}
                onClick={(e => this.onClickFolder(folder))}
                onDragOver={(e) => this.onDragOverItem(e)}
                onDrop={(e) => this.onFolderDrop(e, folder.name)}
              />
            );
          })
        }

        {
          this.props.files.uploads.map(file => {
            return (
              <FileBlock
                key={file.id}
                fileType={file.original_name.split('.').pop().toLowerCase()}
                fileName={file.original_name}
                shared={file.shared}
                image={
                  file.original_name.split('.').pop().toLowerCase() === 'jpg'
                    ||
                    file.original_name.split('.').pop().toLowerCase() === 'jpeg'
                    ||
                    file.original_name.split('.').pop().toLowerCase() === 'png' ?
                    "/api/shared/file?id=" + file.id : null
                }
                mainContainerStyle={{ zIndex: 1, height: 110 }}
                onContextMenu={(e) => this.onContextMenuFile(e, file)}
                onClick={(e => this.onClickFile(file))}
                onDragStart={(e) => this.onFileDrag(e, file.id)}
                //onDrag
              />
            );
          })
        }
        <Menu
          id="files-menu"
          anchorEl={this.state.fileMenuAnchor}
          open={Boolean(this.state.fileMenuAnchor)}
          onClose={() => this.closeMenus()}
          className={classes.menuList}
          onContextMenu={(e) => { e.preventDefault(); this.closeMenus() }}
          onClick={(e) => { e.preventDefault(); this.closeMenus() }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          style={{ marginTop: 80 }}
          BackdropProps={{
            onContextMenu: (e) => { e.preventDefault(); this.closeMenus() },
            onClick: (e) => { e.preventDefault(); this.closeMenus() }
          }}
          hideBackdrop
        >
          <MenuItem className={dropdownItem} onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.shareFile(); this.setState({ shareOpen: true }, () => setTimeout(() => this.closeMenus(), 50)); }}><Share />&nbsp;&nbsp;&nbsp;Share</MenuItem>
          <MenuItem className={dropdownItem} onClick={(e) => this.onClickFile(this.state.selectedFile)}><CloudDownload />&nbsp;&nbsp;&nbsp;Download</MenuItem>
          <MenuItem className={dropdownItem} onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ renameOpen: true, file_new_nameState: '', file_new_name: this.state.selectedFile.original_name }, () => setTimeout(() => this.closeMenus(), 50)); }}><Edit />&nbsp;&nbsp;&nbsp;Rename</MenuItem>
          <MenuItem className={dropdownItem} onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ deleteOpen: true }, () => setTimeout(() => this.closeMenus(), 50)); }}><Delete />&nbsp;&nbsp;&nbsp;Delete</MenuItem>
        </Menu>

        <Menu
          id="folders-menu"
          anchorEl={this.state.folderMenuAnchor}
          open={Boolean(this.state.folderMenuAnchor)}
          onClose={() => this.closeMenus()}
          className={classes.menuList}
          onContextMenu={(e) => { e.preventDefault(); this.closeMenus() }}
          onClick={(e) => { e.preventDefault(); this.closeMenus() }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          style={{ marginTop: 80 }}
          BackdropProps={{
            onContextMenu: (e) => { e.preventDefault(); this.closeMenus() },
            onClick: (e) => { e.preventDefault(); this.closeMenus() }
          }}
          hideBackdrop
        >
          <MenuItem className={dropdownItem} onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.shareFolder(); this.setState({ shareFolderOpen: true }, () => setTimeout(() => this.closeMenus(), 50)); }}><FolderShared />&nbsp;&nbsp;&nbsp;Share</MenuItem>
          {/* <MenuItem className={dropdownItem} onClick={(e) => this.onClickFolder(e, this.state.selectedFolder)}><Archive />&nbsp;&nbsp;&nbsp;Download</MenuItem> */}
          <MenuItem className={dropdownItem} onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ renameFolderOpen: true, folder_new_nameState: '', folder_new_name: this.state.selectedFolder.name }, () => setTimeout(() => this.closeMenus(), 50)); }}><Edit />&nbsp;&nbsp;&nbsp;Rename</MenuItem>
          <MenuItem className={dropdownItem} onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ deleteFolderOpen: true }, () => setTimeout(() => this.closeMenus(), 50)); }}><DeleteSweep />&nbsp;&nbsp;&nbsp;Delete</MenuItem>
        </Menu>

        <Menu
          id="rename-popper"
          anchorEl={this.state.fileMenuAnchor}
          open={this.state.renameOpen}
          onClose={() => this.setState({ renameOpen: false })}
          className={classes.menuList}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          style={{ marginTop: 80 }}
        >
          <div style={{ padding: 10 }}>
            <CustomInput
              success={this.state.file_new_nameState === "success"}
              error={this.state.file_new_nameState === "error"}
              labelText={<span>New Name</span>}
              id="new_name"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                onChange: event => this.setState({ file_new_name: event.target.value }),
                value: this.state.file_new_name,
                onKeyPress: ({ nativeEvent }) => {
                  if (nativeEvent.keyCode == 13) {
                    this.renameFile();
                  }
                }
              }}
            />
            <br />
            <IconButton style={{ float: 'right', marginBottom: 10 }} onClick={() => this.renameFile()}>
              <FontAwesomeIcon icon={faCheck} />
            </IconButton>
          </div>
        </Menu>

        <Menu
          id="delete-popper"
          anchorEl={this.state.fileMenuAnchor}
          open={this.state.deleteOpen}
          onClose={() => this.setState({ deleteOpen: false })}
          className={classes.menuList}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          style={{ marginTop: 80 }}
        >
          <div style={{ padding: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <IconButton style={{ flex: 1, width: 50 }} onClick={() => this.setState({ deleteOpen: false })}>
              <FontAwesomeIcon icon={faTimes} color={"#f00"} />
            </IconButton>
            <IconButton style={{ flex: 1 }} onClick={() => this.deleteFile()}>
              <FontAwesomeIcon icon={faCheck} color={"#0f0"} />
            </IconButton>
          </div>
        </Menu>

        <Menu
          id="share-popper"
          anchorEl={this.state.fileMenuAnchor}
          open={this.state.shareOpen}
          onClose={() => this.setState({ shareOpen: false })}
          className={classes.menuList}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          style={{ marginTop: 80 }}
        >
          <div style={{ padding: 10, overflow: 'hidden' }}>
            <CustomInput
              id="sharable_link"
              labelText={<span>Sharable Link:</span>}
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                value: this.state.selectedFile ? window.location.protocol + "//" + window.location.hostname + '/api/shared/file?id=' + this.state.selectedFile.id : '',
                readOnly: true,
                onClick: () => {
                  this.textArea.select();
                  document.execCommand('copy');
                  this.setState({ shareCopied: true }, () => setTimeout(() => this.setState({ shareCopied: false }), 3000));
                }
              }}
            />
            {
              this.state.shareCopied ?
                <div style={{ color: '#3c3', width: '100%', textAlign: 'center' }}>
                  Link Copied!
                </div>
                :
                <div>&nbsp;</div>
            }
            <form style={{ height: 0, opacity: 0, width: 0 }}>
              <textarea
                ref={(textarea) => this.textArea = textarea}
                value={this.state.selectedFile ? window.location.protocol + "//" + window.location.hostname + (window.location.port !== "80" && window.location.port !== "443" ? ":" + window.location.port : "") + '/api/shared/file?id=' + this.state.selectedFile.id : ''}
              />
            </form>
          </div>
        </Menu>

        
        <Menu
          id="rename-folder-popper"
          anchorEl={this.state.folderMenuAnchor}
          open={this.state.renameFolderOpen}
          onClose={() => this.setState({ renameFolderOpen: false })}
          className={classes.menuList}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          style={{ marginTop: 80 }}
        >
          <div style={{ padding: 10 }}>
            <CustomInput
              success={this.state.folder_new_nameState === "success"}
              error={this.state.folder_new_nameState === "error"}
              labelText={<span>New Folder Name</span>}
              id="new_folder_name"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                onChange: event => this.setState({ folder_new_name: event.target.value }),
                value: this.state.folder_new_name,
                onKeyPress: ({ nativeEvent }) => {
                  if (nativeEvent.keyCode == 13) {
                    this.renameFolder();
                  }
                }
              }}
            />
            <br />
            <IconButton style={{ float: 'right', marginBottom: 10 }} onClick={() => this.renameFolder()}>
              <FontAwesomeIcon icon={faCheck} />
            </IconButton>
          </div>
        </Menu>

        <Menu
          id="create-folder-popper"
          open={this.state.createFolderOpen}
          onClose={() => this.setState({ createFolderOpen: false })}
          className={classes.menuList}
          anchorReference="anchorPosition"
          anchorPosition={{ top: this.state.emptyTop, left: this.state.emptyLeft }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <div style={{ padding: 10 }}>
            <CustomInput
              success={this.state.nameOfNewFolderState === "success"}
              error={this.state.nameOfNewFolderState === "error"}
              labelText={<span>New Folder Name</span>}
              id="new_new_folder_name"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                onChange: event => this.setState({ nameOfNewFolder: event.target.value }),
                value: this.state.nameOfNewFolder,
                onKeyPress: ({ nativeEvent }) => {
                  if (nativeEvent.keyCode == 13) {
                    this.createFolder();
                  }
                }
              }}
            />
            <br />
            <IconButton style={{ float: 'right', marginBottom: 10 }} onClick={() => this.createFolder()}>
              <FontAwesomeIcon icon={faCheck} />
            </IconButton>
          </div>
        </Menu>


        <Menu
          id="delete-folder-popper"
          anchorEl={this.state.folderMenuAnchor}
          open={this.state.deleteFolderOpen}
          onClose={() => this.setState({ deleteFolderOpen: false })}
          className={classes.menuList}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          style={{ marginTop: 80 }}
        >
          <div style={{ padding: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <IconButton style={{ flex: 1, width: 50 }} onClick={() => this.setState({ deleteFolderOpen: false })}>
              <FontAwesomeIcon icon={faTimes} color={"#f00"} />
            </IconButton>
            <IconButton style={{ flex: 1 }} onClick={() => this.deleteFolder()}>
              <FontAwesomeIcon icon={faCheck} color={"#0f0"} />
            </IconButton>
          </div>
        </Menu>

        <Menu
          id="share-folder-popper"
          anchorEl={this.state.folderMenuAnchor}
          open={this.state.shareFolderOpen}
          onClose={() => this.setState({ shareFolderOpen: false })}
          className={classes.menuList}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          style={{ marginTop: 80 }}
        >
          <div style={{ padding: 10, overflow: 'hidden' }}>
            <CustomInput
              id="sharable_folder_link"
              labelText={<span>Sharable Link:</span>}
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                value: this.state.selectedFolder ? window.location.protocol + "//" + window.location.hostname + (window.location.port !== "80" && window.location.port !== "443" && !!(window.location.port) ? ":" + window.location.port : "") + '/api/shared/folder?name=' + encodeURIComponent(this.state.selectedFolder.name) + "&account_id=" + encodeURIComponent(this.props.customer_id) : '',
                readOnly: true,
                onClick: () => {
                  this.textAreaFolder.select();
                  document.execCommand('copy');
                  this.setState({ shareFolderCopied: true }, () => setTimeout(() => this.setState({ shareFolderCopied: false }), 3000));
                }
              }}
            />
            {
              this.state.shareFolderCopied ?
                <div style={{ color: '#3c3', width: '100%', textAlign: 'center' }}>
                  Link Copied!
                </div>
                :
                <div>&nbsp;</div>
            }
            <form style={{ height: 0, opacity: 0, width: 0 }}>
              <textarea
                ref={(textarea) => this.textAreaFolder = textarea}
                value={this.state.selectedFolder ? window.location.protocol + "//" + window.location.hostname + (window.location.port !== "80" && window.location.port !== "443" ? ":" + window.location.port : "") + '/api/shared/folder?name=' + this.state.selectedFolder.name + "&account_id=" + this.props.customer_id : ''}
              />
            </form>
          </div>
        </Menu>

        {
          this.props.files.uploads.length === 0 && this.props.files.folders.length === 0
            ?
            <div
              style={{ position: 'absolute', flex: 1, height: '100%', width: '100%', top: 0, left: 0, right: 0, bottom: 0, zIndex: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
              onContextMenu={(e) => { e.preventDefault(); this.setState({ emptyContextOpen: true, emptyTop: e.clientY, emptyLeft: e.clientX }); }}
            >
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', color: "rgba(0,0,0,0.25)" }}>
                <FontAwesomeIcon icon={faFolderOpen} size="5x" />
                <span style={{ paddingTop: 8, fontWeight: 'bold' }}>No Files...</span>
              </div>
            </div>
            :
            <div
              style={{ position: 'absolute', width: '100%', height: '100%', top: 0, left: 0, right: 0, bottom: 0, zIndex: 0 }}
              onContextMenu={(e) => { e.preventDefault(); this.setState({ emptyContextOpen: true, emptyTop: e.clientY, emptyLeft: e.clientX }); }}
            />
        }

        <Menu
          id="empty-space-context-menu"
          open={this.state.emptyContextOpen}
          onClose={() => this.setState({ emptyContextOpen: false })}
          className={classes.menuList}
          anchorReference="anchorPosition"
          anchorPosition={{ top: this.state.emptyTop, left: this.state.emptyLeft }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}

          onContextMenu={(e) => { e.preventDefault(); this.setState({ emptyContextOpen: false }) }}
          onClick={(e) => { e.preventDefault(); this.setState({ emptyContextOpen: false }) }}
          BackdropProps={{
            onContextMenu: (e) => { e.preventDefault(); this.setState({ emptyContextOpen: false }) },
            onClick: (e) => { e.preventDefault(); this.setState({ emptyContextOpen: false }) }
          }}
          hideBackdrop
        >
          <MenuItem className={dropdownItem} onClick={() => this.setState({ createFolderOpen: true })}><CreateNewFolder />&nbsp;&nbsp;&nbsp;New Folder</MenuItem>
          {/* <MenuItem className={dropdownItem}><NoteAdd />&nbsp;&nbsp;&nbsp;Upload Files</MenuItem>
          <MenuItem className={dropdownItem}><CloudDownload />&nbsp;&nbsp;&nbsp;Download</MenuItem> */}
        </Menu>

      </div>
    );
  }
}

export default withStyles(customDropdownStyle)(Files);